import { Link } from '@com-delta-idp/mnx-ui-kit';

export interface AEMSnapshot {
  link: Link;
  subtitle: string;
  title: string;
  milesLabel: string;
  MQDLabel: string;
}
